<template>
  <v-row dense>
    <v-col v-if="deletable" cols="auto">
      <v-skeleton-loader :loading="skeleton" type="button">
        <v-btn
          color="error"
          depressed
          @click="$emit('delete')"
          v-text="'Удалить'"
        />
      </v-skeleton-loader>
    </v-col>

    <v-col cols="auto">
      <slot name="left" />
    </v-col>

    <v-spacer />

    <v-col cols="auto">
      <slot name="right" />
    </v-col>

    <v-col v-if="editable" cols="auto">
      <v-skeleton-loader :loading="skeleton" type="button">
        <v-btn
          :to="editRoute"
          depressed
          @click="$emit('edit')"
          v-text="'Редактировать'"
        />
      </v-skeleton-loader>
    </v-col>

    <v-col v-if="saveable" cols="auto">
      <v-skeleton-loader :loading="skeleton" type="button">
        <v-btn-toggle borderless dense>
          <v-btn
            :loading="loading"
            depressed
            @click="onSave(saveSettings)"
            v-text="saveSettings.label"
          />

          <template v-if="saveMenuListPartly.length">
            <v-divider vertical />

            <BFormButtonsMenuSave
              :disabled="loading"
              :list="saveMenuListPartly"
              @select="onSave"
            />
          </template>
        </v-btn-toggle>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
import BFormButtonsMenuSave from './BFormButtons/BFormButtonsMenuSave.vue'
import * as SAVE_MENUS from './BFormButtons/save-menus'

export { SAVE_MENUS }

export default {
  name: 'BFormButtons',
  components: {
    BFormButtonsMenuSave,
  },
  props: {
    loading: Boolean,
    skeleton: Boolean,
    editRoute: [String, Object],
    saveable: Boolean,
    editable: Boolean,
    deletable: Boolean,
    saveMenuList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    currentSaveIndex: 0,
  }),
  computed: {
    saveSettings() {
      return this.saveMenuList[this.currentSaveIndex]
    },
    saveMenuListPartly() {
      const list = this.saveMenuList.slice()
      list.splice(this.currentSaveIndex, 1)
      return list
    },
  },
  methods: {
    onSave(action) {
      const index = this.saveMenuList.indexOf(action)
      if (index !== -1) this.currentSaveIndex = index

      this.$emit(action.name, action)
      this.$emit('save-menu', action)
    },
  },
}
</script>
